// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__19kvN","list":"BalanceDue_list__14w9j","listRow":"BalanceDue_listRow__1VEQq","total":"BalanceDue_total__2gTYr"};